import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface INameProps {
  psl?: boolean;
}

export const TextDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Name = styled.div`
  font-weight: bold;
  font-family: Komet;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;

  &:after {
    content: "PSL";
    width: 20px;
    height: 20px;
    color: #666;
    padding: 1px 5px;
    margin-left: 5px;
    font-family: sans-serif;
    letter-spacing: 0.05em;
    font-weight: bold;
    font-size: 0.7em;
    border-radius: 8px;
    border: ${(props: INameProps) => props.psl && "1px solid #666"};
    background-color: ${(props: INameProps) => props.psl && "#fff"};
    display: ${(props: INameProps) => (props.psl ? "inline" : "none")};
    text-transform: uppercase;
    position: relative;
    top: -2px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 180px);
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 70px);
  }
`;

export const Company = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.85em;

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 180px);
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 70px);
  }
`;
